export enum FormFieldType {
    TEXT = "text",
    PASSWORD = "password",
    // to be updated if the form increases
    TEXTAREA = "textarea",
    SELECT = "select",
    INPUT = "INPUT",   
}


export type TaskType = "medical_payment" | "appointment_followup"


export type Task = {
    task_id: string
    type?: TaskType
    status: string
    cost: number
    created_at: string
    dosage: string
    duration?: string
    instructions?: string | null
    prescription_id?: string
    medication_id?: string
}